import {WishlistItem} from "./WishlistItem";

export class Wishlist{

    items : [WishlistItem]
    items_count : number
}